import React from 'react';
import { Helmet } from 'react-helmet-async';
import { Header } from '../components/Header';
import { Footer } from '../components/Footer';

const ImpressumPage = () => {
  return (
    <div className="min-h-screen bg-white">
      <Helmet>
        <title>Impressum - Dein Gutachten Direkt</title>
        <meta name="robots" content="index, follow" />
        <link rel="canonical" href="https://www.dein-gutachten-direkt.de/impressum" />
      </Helmet>
      
      <Header />
      
      <main className="pt-24 pb-16">
        <div className="max-w-4xl mx-auto px-6">
          <h1 className="text-4xl font-bold text-gray-900 mb-12">Impressum</h1>
          
          {/* Angaben gemäß § 5 TMG */}
          <section className="mb-12">
            <h2 className="text-2xl font-bold text-gray-900 mb-4">Angaben gemäß § 5 TMG</h2>
            <div className="prose prose-lg">
              <p className="text-gray-700 mb-2">
                <strong>Dein-Gutachten-Direkt GbR</strong>
              </p>
              <p className="text-gray-700 mb-2">
                vertreten durch die Gesellschafter:
              </p>
              <p className="text-gray-700 mb-4">
                Burak Kaya und Subyr Fayazi
              </p>
              
              <p className="text-gray-700 mb-2">
                <strong>Adresse:</strong>
              </p>
              <p className="text-gray-700 mb-1">Möwenstraße 2</p>
              <p className="text-gray-700 mb-4">25462 Rellingen</p>
              <p className="text-gray-700 mb-4">Deutschland</p>
              
              <p className="text-gray-700 mb-2">
                <strong>Kontakt:</strong>
              </p>
              <p className="text-gray-700 mb-1">
                E-Mail: <a href="mailto:info@dein-gutachten-direkt.de" className="text-brand-green hover:text-brand-green-dark">info@dein-gutachten-direkt.de</a>
              </p>
              <p className="text-gray-700">
                Telefon: <a href="tel:041018471160" className="text-brand-green hover:text-brand-green-dark">04101 8471160</a>
              </p>
            </div>
          </section>
          
          {/* Verantwortlich für den Inhalt */}
          <section className="mb-12 pt-8 border-t border-gray-200">
            <h2 className="text-2xl font-bold text-gray-900 mb-4">Verantwortlich für den Inhalt nach § 18 Abs. 2 MStV</h2>
            <div className="prose prose-lg">
              <p className="text-gray-700 mb-1">Burak Kaya und Subyr Fayazi</p>
              <p className="text-gray-700">Möwenstraße 2, 25462 Rellingen</p>
            </div>
          </section>
          
          {/* Umsatzsteuer */}
          <section className="mb-12 pt-8 border-t border-gray-200">
            <h2 className="text-2xl font-bold text-gray-900 mb-4">Umsatzsteuer</h2>
            <div className="prose prose-lg">
              <p className="text-gray-700 mb-2">Gemäß § 27a Umsatzsteuergesetz:</p>
              <p className="text-gray-700">Umsatzsteuer-Identifikationsnummer: nicht vorhanden</p>
            </div>
          </section>
          
          {/* Streitschlichtung */}
          <section className="pt-8 border-t border-gray-200">
            <h2 className="text-2xl font-bold text-gray-900 mb-4">Streitschlichtung</h2>
            <div className="prose prose-lg">
              <p className="text-gray-700 mb-4">
                Die Europäische Kommission stellt eine Plattform zur Online-Streitbeilegung (OS) bereit:<br />
                <a 
                  href="https://ec.europa.eu/consumers/odr" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="text-brand-green hover:text-brand-green-dark"
                >
                  https://ec.europa.eu/consumers/odr
                </a>
              </p>
              <p className="text-gray-700">
                Wir sind nicht verpflichtet und nicht bereit, an einem Streitbeilegungsverfahren vor einer Verbraucherschlichtungsstelle teilzunehmen.
              </p>
            </div>
          </section>
        </div>
      </main>
      
      <Footer />
    </div>
  );
};

export default ImpressumPage;
